import React from 'react';
import './style.css'


const Kucoin = () => {
      return (
        <div className="drop">
           <img className="kucoinimg" src={process.env.PUBLIC_URL + '/kucoin.jpg'} alt="kucoin" />
           




        </div>
      );
    }
  

export default Kucoin;
